// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ncnVCA7Zm09xqpJTTy_b{flex-direction:column;display:flex}.KHK3NdjSUAz4z3WDEick{margin-top:40px}.sSR7BgsI_hM0B2IzrW7o{flex-direction:column;gap:8px;margin-top:40px;display:flex}.sSR7BgsI_hM0B2IzrW7o.bDKF35ISpMwt0J04fH6M{margin-top:24px}.FspclF27t7kvhR6EFJ3s{background-color:var(--background-neutral-subtle);border-radius:8px;flex-direction:column;gap:16px;margin-top:40px;padding:16px;display:flex}.NIzpg63P60cKfblfpDAK{padding:4px 0}.HJ24Dd_jHaMyplVOwewq{border-color:var(--black-20)}.wSFhb6Q9q1QiJl0vgQde{flex-direction:column;gap:4px;display:flex}.OrBnbEZvLhoKmq5yRD8H{justify-content:space-between;align-items:center;gap:16px;padding:4px 0;display:flex}.PNhyod4DG5wI7MJOhjI2{cursor:pointer;align-items:flex-start;gap:8px;margin-top:20px;padding:8px;display:flex}.JeE4ZEsasPgPBbMxADFL{flex-shrink:0}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `ncnVCA7Zm09xqpJTTy_b`,
	"feesAlert": `KHK3NdjSUAz4z3WDEick`,
	"list": `sSR7BgsI_hM0B2IzrW7o`,
	"listWithAlert": `bDKF35ISpMwt0J04fH6M`,
	"feeBox": `FspclF27t7kvhR6EFJ3s`,
	"feeNote": `NIzpg63P60cKfblfpDAK`,
	"feeDivider": `HJ24Dd_jHaMyplVOwewq`,
	"feeRows": `wSFhb6Q9q1QiJl0vgQde`,
	"feeRow": `OrBnbEZvLhoKmq5yRD8H`,
	"consent": `PNhyod4DG5wI7MJOhjI2`,
	"consentCheckbox": `JeE4ZEsasPgPBbMxADFL`
};
export default ___CSS_LOADER_EXPORT___;
